const brDivergence = {
  divergence: {
    table: {
      loading: 'Carregando pedidos...',
      noData: 'Nenhum pedido encontrado',
      requestedByHint:
        'Host que se deslocou até o imóvel e pediu o reembolso. Pode não ser quem executou o serviço, se o agendamento foi reaberto.',
      headers: {
        code: 'Código',
        type: 'Tipo',
        realty: 'Imóvel',
        host: 'Host',
        realEstate: 'Imobiliária',
        createdAt: 'Criado em',
        status: 'Status',
        items: 'Itens',
        estimated: 'Estimativa',
      },
    },

    type: {
      AREA: 'Metragem incorreta',
      FURNITURE: 'Mobília',
      TROUSSEAU: 'Enxoval',
      DISPLACEMENT: 'Deslocamento',
      TRIP_REIMBURSEMENT: 'Reembolso',
    },

    kind: {
      RECALCULATION: 'Recálculo',
      REIMBURSEMENT: 'Reembolso',
    },

    status: {
      AWAITING_APPROVAL: 'Pendente',
      AWAITING_PAYMENT: 'Aguardando pagamento',
      PAID: 'Pago',
      APPROVED: 'Recalculado',
      REFUSED: 'Negado',
      CONTESTED: 'Contestado',
      REVERSED: 'Estornado',
    },

    filters: {
      status: 'Status',
      type: 'Tipo',
      kind: 'Natureza',
    },

    queue: {
      pendingFor: 'Aguardando há {hours}h',
      finished: 'Sem itens pendentes',
    },

    actions: {
      review: 'Analisar',
      recalculate: 'Recalcular',
      refuse: 'Negar',
      close: 'Fechar',
      reverse: 'Estornar',
      contest: 'Contestar',
      back: 'Voltar',
      confirm: 'Confirmar',
      approveReimbursement: 'Aprovar reembolso',
    },

    review: {
      title: 'Pedido de recálculo',
      reimbursementTitle: 'Pedido de reembolso',
      reimbursementItems: 'Ida informada pelo host',
      appointment: 'Agendamento',
      host: 'Host',
      realEstate: 'Imobiliária',
      items: 'Divergências informadas',
      registered: 'Cadastro atual',
      declared: 'Informado pelo host',
      squareMeters: '{value} m²',
      hasFeature: 'Tinha no local',
      notInRegistry: 'Não consta no cadastro',
      checkIn: 'Checkin do host',
      checkInMap: 'Ver no mapa',
      checkInFailed: 'Não foi possível consultar o checkin',
      noCheckInLocation: 'Sem localização registrada',
      distanceFromRealty: '{value} do imóvel',
      distanceHint: 'Distância em linha reta entre o checkin do host e o imóvel. No deslocamento, mede contra o imóvel mais próximo do agendamento.',
      distanceFarHint: 'O checkin ficou longe do imóvel. Vale conferir a evidência antes de aprovar.',
      description: 'Descrição do host',
      noDescription: 'Sem descrição',
      delta: 'Efeito do recálculo',
      hostDelta: 'Host recebe',
      realEstateDelta: 'Imobiliária paga',
      previousTotal: 'Valor atual',
      newTotal: 'Valor recalculado',
      simulating: 'Calculando...',
      complementary:
        'O pagamento original não pode ser estornado (já transferido, com nota emitida, ou extrato divergente do cálculo atual). O ajuste será lançado como pagamento complementar apenas da diferença.',
      openAppointment: 'Abrir o agendamento em nova aba',
      noHostShare:
        'O contrato desta imobiliária não tem taxa de repasse configurada para este item, então o host não recebe nada deste ajuste. A cobrança da imobiliária está correta. Se o host deveria receber, ajuste o contrato antes de aprovar.',
      evidence: 'Fotos enviadas',
      noEvidence: 'Sem foto anexada',
      openPhoto: 'Abrir a foto em nova aba',
      photoUnavailable: 'Não foi possível carregar esta foto',
      appliedDelta:
        'Valor já lançado',
      nothingToDo:
        'Este pedido já está resolvido. Nada a fazer aqui.',
      contestReason:
        'Motivo da contestação',
      contestReasonHint:
        'Mínimo de 10 caracteres. É o que vai justificar o estorno no extrato.',
      reviewCommentLabel: 'Observação da análise',
      contestReasonLabel:
        'Motivo da contestação',
      confirmContest:
        'Registrar a contestação? Nenhum valor será alterado agora — o estorno é um passo separado.',
      confirmReverse:
        'Confirmar o estorno? O ajuste será desfeito.',
      confirmReverseWithValues:
        'Confirmar o estorno? O host devolve {host} e a imobiliária recupera {realEstate}.',
      reviewComment: 'Observação da análise',
      reviewCommentHint:
        'Na negativa, este texto vai para o host como motivo. Na aprovação, fica só para o time.',
      selectItem: 'Incluir esta divergência na decisão',
      selectAtLeastOne: 'Marque ao menos uma divergência para aprovar ou negar.',
      partialSelection: 'As divergências não marcadas continuam pendentes e podem ser decididas depois, numa nova análise.',
      noPendingItems: 'Este pedido não tem itens pendentes de análise.',
      confirmRecalculate:
        'Confirmar o recálculo? O cadastro do imóvel será corrigido e os valores serão relançados.',
      confirmRecalculateWithValues:
        'Confirmar o recálculo? O cadastro do imóvel será corrigido, o host recebe {host} e a imobiliária paga {realEstate}.',
      confirmRefuse: 'Confirmar a negativa? Nenhum valor será alterado.',
      notApplicable: 'Não se aplica',
      canceledAt: 'Cancelado em',
      cancelReason: 'Motivo do cancelamento',
      noCancelReason: 'Sem motivo registrado',
      reimbursementExplainer:
        'Pedido de reembolso: o host foi até o imóvel e o serviço foi cancelado no local. Aprovar lança o valor na carteira do host que se deslocou, como avulso, mesmo que o agendamento esteja hoje com outro host.',
      requestDescription: 'Relato do host',
      chargeRealEstate: 'Cobrar da imobiliária',
      chargeRealEstateHint: 'A imobiliária paga o valor cheio e o host recebe a taxa do host; a nota do host sai contra o CNPJ dela. Sem marcar, a Hauseful arca e o host recebe o valor cheio.',
      reimbursementHostPercent: 'Taxa do host',
      reimbursementHostPercentHint: 'Vem do contrato e pode ser trocada. Como no contrato, 0% o host não recebe nada.',
      reimbursementHostPercentInvalid: 'Informe uma taxa entre 0 e 100',
      displacementValue: 'Valor do deslocamento',
      approvedDisplacementValue: 'Valor aprovado do deslocamento',
      displacementValueSuggested: 'Sugerido pelo host: {value}. O recálculo usa o valor informado aqui.',
      displacementValueHint: 'O host não informa valor: digite o valor do deslocamento. A imobiliária paga o valor e o host recebe a parte do contrato.',
      notDeclared: 'Não informado',
      approvedReimbursementValue: 'Valor aprovado',
      reimbursementValue: 'Valor do reembolso',
      reimbursementContractShare: 'A taxa de deslocamento do contrato é {percent}%: cobrando a imobiliária, ela vem na taxa do host, que pode ser trocada. Sem cobrar, o host recebe o valor cheio.',
      reimbursementContractNoShare: 'O contrato não repassa deslocamento ao host (0%): cobrando a imobiliária, ele não recebe nada, a não ser que a taxa do host seja trocada. Sem cobrar, recebe o valor cheio.',
      reimbursementContractShareUnknown: 'Não foi possível ler a taxa de deslocamento do contrato. Cobrando a imobiliária, informe a taxa do host.',
      reimbursementPreviewCharging: 'A imobiliária paga {value} e o host recebe {hostValue}.',
      reimbursementPreviewFull: 'O host recebe {value} e a Hauseful arca com o valor.',
      reimbursementHostReceived: 'Repasse ao host',
      confirmReimbursement: 'Aprovar o reembolso? O valor é lançado na carteira do host.',
      confirmReimbursementWithValue:
        'Aprovar o reembolso de {value}? O valor é lançado na carteira do host e a Hauseful arca com ele.',
      confirmReimbursementCharging:
        'Aprovar o reembolso de {value}? A imobiliária paga {value} e o host recebe {hostValue}.',
    },

    messages: {
      reverse: 'Ajuste estornado',
      contest: 'Contestação registrada',
      approve: 'Recálculo aplicado',
      approveReimbursement: 'Reembolso aprovado e lançado na carteira do host.',
      refuse: 'Pedido negado',
    },
  },
}

export default brDivergence
